export const AiTipsIcon = ({ active }: { active: boolean }) => {
    const fillColor = active ? "#031423" : "currentColor";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
        >
            <mask
                id="mask0_4012_6379"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="33"
                height="32"
            >
                <rect
                    x="0.875"
                    y="0.5"
                    width="31"
                    height="31"
                    fill="#D9D9D9"
                    stroke="black"
                />
            </mask>
            <g mask="url(#mask0_4012_6379)">
                <path
                    d="M25.575 26H23.375M12.875 6H24.875C25.1511 6 25.375 6.22386 25.375 6.5V20.5C25.375 20.7761 25.1511 21 24.875 21H24.375C23.8227 21 23.375 21.4477 23.375 22V26M12.875 6H10.875C9.49429 6 8.375 7.11929 8.375 8.5V23.5M12.875 6V21M12.875 21H10.875C9.49429 21 8.375 22.1193 8.375 23.5V23.5C8.375 24.8807 9.49429 26 10.875 26H23.375M12.875 21H24.375"
                    stroke={fillColor}
                    strokeWidth="2.2"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    );
};
